import { MarkerTemplatesConstants } from '../_constants';
import { MarkerTemplatesService } from '../_services';

export const MarkerTemplatesActions = {
  loadFromChronicle,
  getWorldTemplates,
  getTemplate,
  updateTemplate,
  createTemplate,
  deleteTemplate,
};

function loadFromChronicle(payload) {
  return {
    type: MarkerTemplatesConstants.POPULATE_MARKERTEMPLATES,
    payload,
  };
}

function getWorldTemplates(worldID) {
  return (dispatch) => {
    dispatch(request({ worldID }));

    return MarkerTemplatesService.fetchWorldTemplates(worldID).then(
      (templates) => {
        dispatch(success(templates));
        return templates;
      },
      (error) => {
        const message = error.toString();
        console.log(
          '[CHRONOS] Error: Fetching Marker Templates By World',
          message
        );
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: MarkerTemplatesConstants.GET_WORLD_TEMPLATES_REQUEST,
      params,
    };
  }

  function success(payload) {
    return {
      type: MarkerTemplatesConstants.GET_WORLD_TEMPLATES_SUCCESS,
      payload,
    };
  }

  function failure(error) {
    return {
      type: MarkerTemplatesConstants.GET_WORLD_TEMPLATES_FAILURE,
      error,
    };
  }
}

function getTemplate(templateID) {
  return (dispatch) => {
    dispatch(request({ templateID }));

    return MarkerTemplatesService.fetchTemplate(templateID).then(
      (template) => {
        dispatch(success(template));
        return template;
      },
      (error) => {
        const message = error.toString();
        console.log('[CHRONOS] Error - Fetching Marker Template', message);
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: MarkerTemplatesConstants.GET_TEMPLATE_REQUEST,
      params,
    };
  }

  function success(payload) {
    return {
      type: MarkerTemplatesConstants.GET_TEMPLATE_SUCCESS,
      payload,
    };
  }

  function failure(error) {
    return {
      type: MarkerTemplatesConstants.GET_TEMPLATE_FAILURE,
      error,
    };
  }
}

function updateTemplate(templateID, templateData) {
  return (dispatch) => {
    dispatch(request({ templateID, templateData }));

    return MarkerTemplatesService.saveTemplate(templateID, templateData).then(
      (template) => {
        dispatch(success(template));
        return template;
      },
      (error) => {
        const message = error.toString();
        console.log('[CHRONOS] Error - Updating Marker Template', message);
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: MarkerTemplatesConstants.UPDATE_TEMPLATE_REQUEST,
      params,
    };
  }

  function success(payload) {
    return {
      type: MarkerTemplatesConstants.UPDATE_TEMPLATE_SUCCESS,
      payload,
    };
  }

  function failure(error) {
    return {
      type: MarkerTemplatesConstants.UPDATE_TEMPLATE_FAILURE,
      error,
    };
  }
}

function createTemplate(templateData) {
  return (dispatch) => {
    dispatch(request({ templateData }));

    return MarkerTemplatesService.createTemplate(templateData).then(
      (template) => {
        dispatch(success(template));
        return template;
      },
      (error) => {
        const message = error.toString();
        console.log('[CHRONOS] Error - Creating new Marker Template', message);
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: MarkerTemplatesConstants.CREATE_TEMPLATE_REQUEST,
      params,
    };
  }

  function success(payload) {
    return {
      type: MarkerTemplatesConstants.CREATE_TEMPLATE_SUCCESS,
      payload,
    };
  }

  function failure(error) {
    return {
      type: MarkerTemplatesConstants.CREATE_TEMPLATE_FAILURE,
      error,
    };
  }
}

function deleteTemplate(templateID) {
  return (dispatch) => {
    dispatch(request({ templateID }));

    return MarkerTemplatesService.deleteTemplate(templateID).then(
      () => {
        dispatch(success(templateID));
        // return templateID;
      },
      (error) => {
        const message = error.toString();
        console.log('[CHRONOS] Error - Deleting a Marker Template', message);
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: MarkerTemplatesConstants.DELETE_TEMPLATE_REQUEST,
      params,
    };
  }

  function success(payload) {
    return {
      type: MarkerTemplatesConstants.DELETE_TEMPLATE_SUCCESS,
      payload,
    };
  }

  function failure(error) {
    return {
      type: MarkerTemplatesConstants.DELETE_TEMPLATE_FAILURE,
      error,
    };
  }
}
